import i18n from "@/i18n"
import { RouteRecordRaw } from "vue-router"

const { t } = i18n.global

export const projetosRotas = (): RouteRecordRaw[] => [
  {
    path: "/projetos",
    name: "Projetos",
    meta: {
      titulo: t("tituloDaRotaDeProjetos"),
      regras: ["auth", "cancelador"],
      modulo: "Projetos",
      operador: "ou",
      permissoes: ["criar:ambos", "visualizar:ambos"],
    },
    component: () =>
      import(
        /* webpackChunkName: "Profissionais" */
        "@/paginas/Projetos/ListaDeProjetos/ListaDeProjetos.vue"
      ),
  },
  {
    path: "/novo-projeto",
    name: "NovoProjeto",
    meta: {
      titulo: t("tituloDaRotaDeCriarProjeto"),
      regras: ["auth", "cancelador"],
      modulo: "Projetos",
      operador: "e",
      permissoes: ["criar:ambos"],
    },
    component: () =>
      import(
        /* webpackChunkName: "EditarProjeto" */ "@/paginas/Projetos/NovoProjeto/NovoProjeto.vue"
      ),
  },
  {
    path: "/novo-projeto/:id",
    name: "EditarProjeto",
    meta: {
      titulo: t("tituloDaRotaDeEditarProjeto"),
      regras: ["auth", "cancelador"],
      modulo: "Projetos",
      operador: "e",
      permissoes: ["editar:ambos"],
    },
    component: () =>
      import(
        /* webpackChunkName: "EditarProjeto" */ "@/paginas/Projetos/NovoProjeto/NovoProjeto.vue"
      ),
  },
  {
    path: "/novo-grupo",
    name: "NovoGrupo",
    meta: {
      titulo: t("tituloDaRotaDeCriarGrupo"),
      regras: ["auth", "cancelador"],
      modulo: "Projetos",
      operador: "e",
      permissoes: ["criar:ambos"],
    },
    component: () =>
      import(
        /* webpackChunkName: "Projetos" */ "@/paginas/Projetos/NovoGrupo/NovoGrupo.vue"
      ),
  },
  {
    path: "/novo-grupo",
    name: "NovoGrupo",
    meta: {
      titulo: t("tituloDaRotaDeCriarGrupo"),
      regras: ["auth", "cancelador"],
      modulo: "Projetos",
      operador: "e",
      permissoes: ["criar:ambos"],
    },
    component: () =>
      import(
        /* webpackChunkName: "Projetos" */ "@/paginas/Projetos/NovoGrupo/NovoGrupo.vue"
      ),
  },
]
